<template>
  <span class="block text-error text-xs font-semibold max-w-[400px] whitespace-pre-line" v-if="errorText != null && errorText.length > 0">
    {{ errorText }}
  </span>
</template>

<script setup lang="js">
import { computed } from 'vue'
import { ApiGatewayResponse, HttpStatusCode } from '@/api/ApiGateway.js'

const props = defineProps({
	errors: { type: ApiGatewayResponse, default: null },
	field: { type: String, default: null }
})

const errorText = computed(() =>
{
	if (props.errors === null)
	{
		return null
	}
	if (!(props.errors?.hasError(true) ?? false))//Pass true to prevent error banner spam due to computed
	{
		return null
	}
	if (props.field !== null)
	{
		// Show Validation Error
		const validationErrors = props.errors?.validationErrors() ?? []
		for (const i in validationErrors)
		{
			if (validationErrors[i].source === props.field)
			{
				return validationErrors[i].detail
			}
		}
		return null
	}
	else
	{
		// Generic Error ... See if there is one
		const otherErrors = props.errors?.errorsNotOfStatus(HttpStatusCode.ValidationError) ?? []
		const errorTexts = []
		for (const i in otherErrors)
		{
			errorTexts.push(otherErrors[i].detail)
		}
		if (errorTexts.length <= 0)
		{
			const validationErrors = props.errors?.validationErrors() ?? []
			if (validationErrors.length <= 0)
			{
				return 'An unknown error was encountered.'
			}
			return null
		}
		return errorTexts.join('. ')
	}
})
</script>
